import { isSameTime, isValidDate, TimeUnit } from 'src/utils/time';
import { Message } from '../../../types';

export const sameAuthor = (
  currentMessage: Message,
  nextMessage: Message | undefined,
) => nextMessage !== undefined && currentMessage.author === nextMessage.author;

export const showDate = (
  currentMessage: Message,
  previousMessage: Message | undefined,
) => {
  if (previousMessage === undefined) {
    return true;
  }

  if (!isValidDate(previousMessage.createdAt)) {
    return true;
  }

  if (!isValidDate(currentMessage.createdAt)) {
    return false;
  }

  return !isSameTime(
    previousMessage.createdAt,
    currentMessage.createdAt,
    TimeUnit.days,
  );
};

export const showMinute = (currentMessage: Message, nextMessage?: Message) => {
  if (!nextMessage) {
    return true;
  }

  const nextTimestamp = nextMessage.deletedAt ?? nextMessage.createdAt;

  if (!isValidDate(nextTimestamp)) {
    return true;
  }

  if (!isValidDate(currentMessage.createdAt)) {
    return false;
  }

  return (
    !isSameTime(currentMessage.createdAt, nextTimestamp, TimeUnit.minutes) ||
    !sameAuthor(currentMessage, nextMessage)
  );
};
